export { default } from './SpotReportSummary';
